import { Github, Linkedin, Mail, BookOpen } from "lucide-react";
import { PROFILE } from "../data/portfolio";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 py-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 items-center">
          <div className="col-span-12 md:col-span-6">
            <p className="font-display font-black text-3xl tracking-tighter">
              {PROFILE.name}<span className="text-white/30">.</span>
            </p>
            <p className="label-eyebrow mt-2">© {new Date().getFullYear()} — All rights reserved</p>
          </div>
          <div className="col-span-12 md:col-span-6 flex md:justify-end items-center gap-6">
            <a
              data-testid="footer-email"
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(PROFILE.email)}`}
              target="_blank"
              rel="noreferrer"
              className="text-white/60 hover:text-white transition-colors"
              aria-label="Email"
            >
              <Mail size={18} />
            </a>
            <a
              data-testid="footer-linkedin"
              href={PROFILE.linkedin}
              target="_blank"
              rel="noreferrer"
              className="text-white/60 hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={18} />
            </a>
            <a
              data-testid="footer-github"
              href={PROFILE.github}
              target="_blank"
              rel="noreferrer"
              className="text-white/60 hover:text-white transition-colors"
              aria-label="GitHub"
            >
              <Github size={18} />
            </a>
            <a
              data-testid="footer-medium"
              href={PROFILE.medium}
              target="_blank"
              rel="noreferrer"
              className="text-white/60 hover:text-white transition-colors"
              aria-label="Medium"
            >
              <BookOpen size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
